import { createFileRoute } from "@tanstack/react-router";
import { noindexHead } from "@/lib/seo";
import Auth from "@/pages/Auth";

export const Route = createFileRoute("/auth")({
  head: noindexHead,
  component: Auth,
});
